import {useTranslation} from '@aboutyou/i18n';
import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES} from '../../../constants/typography';
import {Button} from '../../atoms/Buttons/Button';
import {Divider} from '../../atoms/Divider/Divider';
import {Icon} from '../../atoms/Icon/Icon';
import {PushNotificationIconName} from './assets';

interface PushNotificationBodyProps {
  onBodyContentClick?: () => void;
  onClose: () => void;
}

export const PushNotificationBody: FC<PushNotificationBodyProps> = ({
  onBodyContentClick = () => {},
  onClose,
}) => {
  const {t} = useTranslation();

  return (
    <>
      <ProposalListContainer>
        <ProposalList>
          <ProposalItem>
            <StyledIcon
              data-testid="PushNotificationListSalesIcon"
              asset={PushNotificationIconName.Gift}
              size="S"
            />
            <span>{t('Sales & Discounts')}</span>
          </ProposalItem>
          <ProposalItem>
            <StyledIcon
              data-testid="PushNotificationListProductIcon"
              asset={PushNotificationIconName.UspAuthenticityCheck}
              size="S"
            />
            <span>{t('Product availability')}</span>
          </ProposalItem>
          <ProposalItem>
            <StyledIcon
              data-testid="PushNotificationListOrderIcon"
              asset={PushNotificationIconName.Truck}
              size="S"
            />
            <span>{t('Order and delivery status')}</span>
          </ProposalItem>
        </ProposalList>
      </ProposalListContainer>
      <Description>
        {t(
          'You can manage push notifications in your browser settings at any time',
        )}
      </Description>
      <Divider />
      <BottomCtaWrapper>
        <Button
          data-testid="PushNotificationCancelButton"
          onClick={onClose}
          variant="secondary"
        >
          {t('Cancel')}
        </Button>
        <StyledButton
          data-testid="PushNotificationAgreeButton"
          onClick={onBodyContentClick}
        >
          {t('Yes, please!')}
        </StyledButton>
      </BottomCtaWrapper>
    </>
  );
};

const BottomCtaWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 0 1.25rem;
  margin-bottom: 1.5rem;
`;

const StyledIcon = styled(Icon)`
  margin-right: 0.375rem;
`;

const ProposalListContainer = styled.div`
  padding: 0 1.25rem;
`;

const ProposalList = styled.ul`
  padding: 0;
  margin: 0.625rem 0 1.5rem;
  border: 1px solid ${COLORS.Grey3};
  border-radius: 4px;
`;

const ProposalItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.375rem 0.875rem;
  &:first-child {
    padding-top: 0.75rem;
  }
  &:last-child {
    padding-bottom: 0.75rem;
  }
`;

const StyledButton = styled(Button)`
  flex: 1;
`;

const Description = styled.p`
  margin: 0;
  padding: 0 1.25rem;
  font-size: ${FONT_SIZES.px12};
  color: ${COLORS.Grey1};
  text-align: center;
`;
